export const isReservationButtonActive = (is_escrow_enabled, userId, sellerUserId, generalConfig, categoryId) => {
    const isGeneralConfigNotEmpty = generalConfig && typeof generalConfig === 'object' && Object.keys(generalConfig).length > 0;
    const configValue = generalConfig?.enabled ?? null;
    const configCategory = generalConfig?.data?.category_ids ?? null;

    const isCategoryActive = (isGeneralConfigNotEmpty, configValue, configCategory, categoryId) => {
        if (isGeneralConfigNotEmpty && configValue && configCategory && Array.isArray(configCategory)) {
            return configCategory.includes(categoryId);
        }
        return false;
    };

    return is_escrow_enabled === 'enabled'
        && userId !== sellerUserId
        && isCategoryActive(isGeneralConfigNotEmpty, configValue, configCategory, categoryId);
};

